(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rg-tbi-financing"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rg-tbi-financing')) {
    class RgTbiFinancing extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.dialog = this.querySelector('dialog');
        this.trigger = this.querySelector('[data-tbi-open]');
        this.frame = this.querySelector('[data-tbi-frame]');
        this.calculator = this.querySelector('[data-tbi-calculator]');
        this.unavailable = this.querySelector('[data-tbi-unavailable]');
        this.external = this.querySelector('[data-tbi-external]');
        this.loading = this.querySelector('[data-tbi-loading]');
        this.months = this.querySelector('[data-tbi-months]');
        this.rateInput = this.querySelector('[data-tbi-rate]');
        this.premiumInput = this.querySelector('[data-tbi-premium]');
        this.schemes = this.readSchemes();
        if (!this.dialog || !this.trigger) return;
        this.trigger.addEventListener('click', () => {
          this.refresh();
          this.dialog.showModal();
          this.trigger.setAttribute('aria-expanded', 'true');
          this.loadCalculator();
        }, options);
        this.querySelector('[data-tbi-close]').addEventListener('click', () => this.dialog.close(), options);
        this.months.addEventListener('change', () => this.renderEstimate(), options);
        this.rateInput.addEventListener('change', () => this.renderEstimate(), options);
        this.premiumInput.addEventListener('input', () => this.renderEstimate(), options);
        this.frame.addEventListener('load', () => {
          this.loading.hidden = true;
          clearTimeout(this.frameTimer);
          this.querySelector('[data-tbi-slow]').hidden = true;
          this.frame.removeAttribute('aria-busy');
        }, options);
        this.dialog.addEventListener('click', (event) => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        }, options);
        this.dialog.addEventListener('close', () => {
          this.trigger.setAttribute('aria-expanded', 'false');
          this.trigger.focus({ preventScroll: true });
        }, options);
        this.onQuantity = (event) => {
          if (event.target.name !== 'quantity' || event.target.form?.id !== this.dataset.formId) return;
          this.refresh();
          if (this.dialog.open) {
            clearTimeout(this.timer);
            this.timer = setTimeout(() => this.loadCalculator(), 250);
          }
        };
        document.addEventListener('input', this.onQuantity, options);
        document.addEventListener('change', this.onQuantity, options);
        this.refresh();
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        clearTimeout(this.timer);
        clearTimeout(this.frameTimer);
      }

      refresh() {
        const form = document.getElementById(this.dataset.formId);
        const quantity = Number(form?.elements.namedItem('quantity')?.value || 1);
        this.amountCents = Math.round(Number(this.dataset.price) * (Number.isInteger(quantity) && quantity > 0 ? quantity : 1));
        this.amount = this.amountCents / 100;
        this.querySelector('[data-tbi-amount]').textContent = this.money(this.amountCents);
        this.renderEstimate();
      }

      money(cents) {
        return new Intl.NumberFormat(document.documentElement.lang || 'ro-RO', { style: 'currency', currency: 'RON' }).format(cents / 100);
      }

      readSchemes() {
        try {
          const until = this.dataset.schemesUntil;
          if (!/^\d{4}-\d{2}-\d{2}$/.test(until || '') || !Number.isFinite(Date.parse(`${until}T23:59:59Z`)) || new Date(`${until}T23:59:59Z`).toISOString().slice(0, 10) !== until || Date.parse(`${until}T23:59:59Z`) < Date.now()) return [];
          const rows = JSON.parse(this.dataset.schemes || '[]');
          if (!Array.isArray(rows)) return [];
          return rows.filter((row) => {
            const fields = ['period', 'analysis_fee', 'insurance', 'nir', 'installment_factor', 'total_due_factor', 'amount_min', 'amount_max'];
            return row && fields.every((key) => typeof row[key] === 'number' && Number.isFinite(row[key])) &&
              Number.isInteger(row.period) && row.period >= 3 && row.period <= 60 &&
              row.analysis_fee >= 0 && row.insurance >= 0 && row.nir >= 0 &&
              row.installment_factor > 0 && row.total_due_factor >= 1 &&
              Math.abs(row.installment_factor * row.period - row.total_due_factor) < 0.00001 &&
              row.amount_min >= 100 && row.amount_max >= row.amount_min;
          }).sort((a, b) => a.period - b.period || a.installment_factor - b.installment_factor);
        } catch {
          return [];
        }
      }

      quote(scheme) {
        const fee = Math.round(scheme.analysis_fee * 100);
        const principal = this.amountCents + fee;
        const monthly = Math.round(principal * scheme.installment_factor);
        const total = Math.round(principal * scheme.total_due_factor);
        const last = total - monthly * (scheme.period - 1);
        if (![fee, principal, monthly, total, last].every(Number.isSafeInteger) || last <= 0 || total < principal) return null;
        return { fee, monthly, total, last, cost: total - this.amountCents };
      }

      renderEstimate() {
        const validAmount = Number.isSafeInteger(this.amountCents) && this.amountCents > 0;
        this.schemes = this.readSchemes();
        const merchant = this.schemes.length > 0;
        const longTerm = this.amountCents > 200000;
        let choices = merchant ? this.schemes.filter((row) => this.amountCents >= Math.round(row.amount_min * 100) && this.amountCents <= Math.round(row.amount_max * 100)) :
          longTerm ? Array.from({ length: 55 }, (_, index) => ({ period: index + 6, public: true })) : [{ period: 4, public: true }];
        choices = validAmount && this.amountCents >= 10000 ? choices.filter((row) => row.public || this.quote(row)) : [];
        const optionsKey = JSON.stringify(choices);
        if (optionsKey !== this.optionsKey) {
          const previous = this.months.selectedOptions[0]?.dataset.period;
          this.months.replaceChildren(...choices.map((row, index) => {
            const option = document.createElement('option');
            option.value = String(index);
            option.dataset.period = String(row.period);
            option.textContent = `${row.period} ${this.dataset.monthLabel}`;
            if (choices.filter((item) => item.period === row.period).length > 1) option.textContent += ` · ${this.money(this.quote(row).monthly)}`;
            return option;
          }));
          const samePeriod = [...this.months.options].find((option) => option.dataset.period === previous);
          if (samePeriod) this.months.value = samePeriod.value;
          else if (!merchant && longTerm) this.months.value = String(choices.findIndex((row) => row.period === 24));
          this.optionsKey = optionsKey;
        }
        const eligible = choices.length > 0;
        this.querySelector('[data-tbi-estimate]').hidden = !eligible;
        this.querySelector('[data-tbi-range]').hidden = merchant || eligible;
        this.querySelector('[data-tbi-no-scheme]').hidden = !merchant || eligible;
        for (const selector of ['[data-tbi-public-title]', '[data-tbi-public-notice]', '[data-tbi-public-periods]']) this.querySelector(selector).hidden = merchant;
        for (const selector of ['[data-tbi-schemes-title]', '[data-tbi-schemes-notice]']) this.querySelector(selector).hidden = !merchant;
        this.querySelector('[data-tbi-public-controls]').hidden = merchant || !longTerm || !eligible;
        this.querySelector('[data-tbi-method]').hidden = merchant || !eligible;
        this.querySelector('[data-tbi-interest-cost-row]').hidden = merchant;
        this.querySelector('[data-tbi-excluded]').hidden = true;
        this.querySelector('[data-tbi-invalid-premium]').hidden = true;
        if (!eligible) return;
        const scheme = choices[Number(this.months.value)] || choices[0];
        if (!merchant) {
          this.renderPublicQuote(scheme.period);
          return;
        }
        const values = this.quote(scheme);
        for (const [name, value] of Object.entries(values)) this.querySelector(`[data-tbi-${name}]`).textContent = this.money(value);
        this.querySelector('[data-tbi-interest]').textContent = new Intl.NumberFormat(document.documentElement.lang || 'ro-RO', { style: 'percent', maximumFractionDigits: 2 }).format(scheme.nir / 100);
        this.querySelector('[data-tbi-insurance]').textContent = scheme.insurance === 0 ? this.money(0) : this.dataset.insuranceConfirm;
      }

      publicQuote(period, annualRate, premiumCents) {
        const shortTerm = this.amountCents <= 200000;
        if (!Number.isSafeInteger(this.amountCents) || this.amountCents < 10000 ||
          !Number.isSafeInteger(premiumCents) || premiumCents < 0 ||
          !Number.isInteger(period) || (shortTerm ? period !== 4 || annualRate !== 0 || premiumCents !== 0 : period < 6 || period > 60 || ![18, 24, 29].includes(annualRate))) return null;
        const fee = shortTerm ? 4000 : 9500;
        const principal = this.amountCents + fee + premiumCents;
        const rate = annualRate / 1200;
        const payment = rate ? principal * rate / (1 - Math.pow(1 + rate, -period)) : principal / period;
        const monthly = Math.round(payment);
        const total = Math.round(payment * period);
        const last = total - monthly * (period - 1);
        if (![principal, monthly, total, last].every(Number.isSafeInteger) || last <= 0 || total < principal) return null;
        return { fee, monthly, total, last, cost: total - this.amountCents, insurance: premiumCents, 'interest-cost': total - principal };
      }

      renderPublicQuote(period) {
        const longTerm = this.amountCents > 200000;
        const rate = longTerm ? Number(this.rateInput.value) : 0;
        const rawPremium = this.premiumInput.value;
        const premiumValid = !longTerm || (rawPremium !== '' && this.premiumInput.validity.valid && /^\d+(?:\.\d{1,2})?$/.test(rawPremium));
        const premium = longTerm ? Math.round(Number(rawPremium) * 100) : 0;
        const values = premiumValid ? this.publicQuote(period, rate, premium) : null;
        this.premiumInput.setAttribute('aria-invalid', String(!values));
        this.querySelector('[data-tbi-invalid-premium]').hidden = Boolean(values);
        this.querySelector('[data-tbi-estimate]').hidden = !values;
        this.querySelector('[data-tbi-excluded]').hidden = !longTerm || premium > 0 || !values;
        if (!values) return;
        for (const [name, value] of Object.entries(values)) this.querySelector(`[data-tbi-${name}]`).textContent = this.money(value);
        this.querySelector('[data-tbi-interest]').textContent = new Intl.NumberFormat(document.documentElement.lang || 'ro-RO', { style: 'percent', maximumFractionDigits: 2 }).format(rate / 100);
      }

      getCalculatorUrl() {
        try {
          const url = new URL(this.dataset.calculatorUrl);
          if (url.protocol !== 'https:' || url.hostname !== 'ro.tbibank.support' || url.port || !['/calculator/', '/calculator'].includes(url.pathname) || url.username || url.password || !url.searchParams.get('code') || !url.searchParams.get('key') || !Number.isFinite(this.amount) || this.amount <= 0) return null;
          url.searchParams.set('amount', this.amount.toFixed(2));
          return url.href;
        } catch {
          return null;
        }
      }

      updateApplicationLink() {
        const wrapper = this.querySelector('[data-tbi-application]');
        const link = this.querySelector('[data-tbi-apply]');
        wrapper.hidden = true;
        link.removeAttribute('href');
        try {
          const url = new URL(this.dataset.applicationUrl);
          if (url.protocol !== 'https:' || !['tbibank.ro', 'www.tbibank.ro'].includes(url.hostname) || url.port || url.username || url.password || !/^\/landing-pages\/[^/]+\/?$/.test(url.pathname)) return;
          link.href = url.href;
          wrapper.hidden = false;
        } catch {
          return;
        }
      }

      loadCalculator() {
        this.updateApplicationLink();
        const url = this.getCalculatorUrl();
        this.calculator.hidden = !url;
        this.unavailable.hidden = Boolean(url);
        clearTimeout(this.frameTimer);
        this.querySelector('[data-tbi-slow]').hidden = true;
        if (!url) {
          this.loading.hidden = true;
          this.frame.removeAttribute('aria-busy');
          this.frame.removeAttribute('src');
          this.external.removeAttribute('href');
          return;
        }
        if (this.frame.getAttribute('src') !== url) {
          this.loading.hidden = false;
          this.frame.setAttribute('aria-busy', 'true');
          this.frame.src = url;
          this.frameTimer = setTimeout(() => {
            this.loading.hidden = true;
            this.querySelector('[data-tbi-slow]').hidden = false;
            this.frame.removeAttribute('aria-busy');
          }, 12000);
        }
        this.external.href = url;
      }
    }
    customElements.define('rg-tbi-financing', RgTbiFinancing);
  }
  } catch(e) { console.error(e); }
})();

})();
